import React, { useContext, useMemo } from "react";
import { Button, message } from "antd";
import style from "./index.module.scss";
import {
    endQuestionnaire,
    publishQuestionnaire,
    QuestionStatus
} from "../../../../../service/question";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import useRequestFn from "../../../../../utils/useRequestFn";
import { errorMessage } from "../../../../../service/service";
import useModalHandler from "../../../../../utils/v3/useModalHandler";
import EditQuestionModal from "../EditQuestionModal";

interface ListLinksProps {
    status: QuestionStatus;
    id: number;
    reload: () => void;
}

export default function ListLinks({ status, id, reload }: ListLinksProps) {
    const { basename, course } = useContext(CourseContext);
    const { weekTimeId } = course;

    //编辑
    const editModal = useModalHandler({
        component: EditQuestionModal
    });
    function openEditModal() {
        editModal.open({
            id,
            type: "republic",
            onSuccess: () => {
                reload();
                editModal.close();
            }
        });
    }

    const [startAction, { loading: startLoading }] =
        useRequestFn(publishQuestionnaire);

    async function startQuestion() {
        try {
            await startAction(weekTimeId, id);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }
    //投屏
    const history = useHistory();

    const [endAction, { loading: endLoading }] = useRequestFn(endQuestionnaire);

    async function onEndActivityFn() {
        try {
            await endAction(weekTimeId, id);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function gotoEdit() {
        history.push(`${basename}/question/topics/${id}`);
    }

    function gotoStatic() {
        history.push(`${basename}/question/static/${id}`);
    }

    function gotoDetail() {
        history.push(`${basename}/question/detail/${id}`);
    }

    const loading = useMemo(() => {
        return startLoading || endLoading;
    }, [endLoading, startLoading]);

    return (
        <div className={style.root}>
            {status === QuestionStatus.NotStarted && (
                <Button loading={loading} type="link" onClick={startQuestion}>
                    开始问卷
                </Button>
            )}
            {status === QuestionStatus.doing && (
                <Button loading={loading} type="link" onClick={gotoDetail}>
                    进入问卷
                </Button>
            )}
            {status === QuestionStatus.doing && (
                <Button loading={loading} type="link" onClick={onEndActivityFn}>
                    结束问卷
                </Button>
            )}
            {status === QuestionStatus.done && (
                <Button loading={loading} type="link" onClick={openEditModal}>
                    重新发布
                </Button>
            )}
            {status === QuestionStatus.done && (
                <Button loading={loading} type="link" onClick={gotoStatic}>
                    问卷分析
                </Button>
            )}
            {(status === QuestionStatus.NotStarted ||
                status === QuestionStatus.NoChild) && (
                <Button loading={loading} type="link" onClick={gotoEdit}>
                    编辑试题
                </Button>
            )}

            {editModal.render()}
        </div>
    );
}
